import { render, staticRenderFns } from "./profile-links.vue?vue&type=template&id=2388ce6c&scoped=true&"
import script from "./profile-links.vue?vue&type=script&lang=js&"
export * from "./profile-links.vue?vue&type=script&lang=js&"
import style0 from "./profile-links.vue?vue&type=style&index=0&id=2388ce6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388ce6c",
  null
  
)

export default component.exports